import * as Yup from "yup";
import { GeneralTreatingPhysicianFieldController } from "./general-treating-physician-field-controller";

export class TreatingPhysicianEmailFieldController extends GeneralTreatingPhysicianFieldController {
	override createValidationRule(initialData: unknown, translate: (key: string) => string) {
		return (super.createValidationRule(initialData, translate) as Yup.StringSchema).email(translate("not-an-email"));
	}
}
